import Component from '@bythepixel/component-loader';
import MapMarker from './mapMarker';

export default class MapEmbed extends Component {
  static selector = '[data-comp-map-embed]';

  map;
  marker;

  constructor(mapEl, options) {
    super(mapEl, options);
    this.map = options.map;

    this.createMarker();
  }

  createMarker() {
    this.marker = new MapMarker(this.$container.dataset);
    this.map.addMarker(this.marker);

    this.map.flyTo(this.marker, {
      zoom: 10,
    });
  }
}
